import { render, staticRenderFns } from "./PeriodSummary.vue?vue&type=template&id=11531235&scoped=true"
import script from "./PeriodSummary.vue?vue&type=script&lang=js"
export * from "./PeriodSummary.vue?vue&type=script&lang=js"
import style0 from "./PeriodSummary.vue?vue&type=style&index=0&id=11531235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11531235",
  null
  
)

export default component.exports